export default [
  {
    path: '/trust-deed-list',
    name: 'trust-deed-list',
    component: resolve => require(['views/trust-deed/trust-deed-list'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/trust-deed-detail/:id',
    name: 'trust-deed-detail',
    component: resolve => require(['views/trust-deed/trust-deed-detail'], resolve),
    props:true,
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/trust-deed-form/:isEdit/:id',
    name: 'trust-deed-form',
    component: resolve => require(['views/trust-deed/trust-deed-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '全部订单/订单', isForm: true }
  },
  {
    path: '/distribute-task/:billId',
    name: 'distribute-task',
    props:true,
    component: resolve => require(['views/trust-deed/distribute-task'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/bill-lot-operate/:status',
    name: 'bill-lot-operate',
    props:true,
    component: resolve => require(['views/trust-deed/bill-lot-operate'], resolve),
    meta: { auth: true, view: 'pc' }
  }
]
